export { namespace } from './actions';
import { Status, ActionType } from './actions';

const initialState = {
  status: Status.INITIAL,
  data: []
};

export default function creativeMappingReducer(state = initialState, action) {

  switch (action.type) {
    case ActionType.SET_CREATIVE_SDOS: {
      const { creativeSDOs = [] } = action.payload;
      return {
        ...state,
        status: Status.LOADED,
        data: [...creativeSDOs]
      };
    }
    case ActionType.SET_CREATIVE_SDO_STATUS: {
      const { status } = action.payload;
      return {
        ...state,
        status
      }
    }
    default:
      return state;
  }
}
